import type { DiffPosition, DiffRow } from "./diff";

/**
 * The codes to light on a compare board for a set of diff positions, given the modifier
 * face the board is currently showing (the active combo). Only positions on that face
 * light, so a lit cap always displays the changed binding - a change on another modifier
 * layer lights only once that layer is latched. Returns null when nothing is on the
 * active face, so the board reads normally; an empty array would dim every cap instead.
 */
export function faceCodes(positions: DiffPosition[], activeCombo: string): string[] | null {
  const codes = positions.filter((p) => p.combo === activeCombo).map((p) => p.code);
  return codes.length > 0 ? codes : null;
}

/**
 * The modifier combo a Changes-row click should latch: the first non-base combo the row
 * occupies, preferring the B-side. Positions are sorted base-first, so taking index 0
 * would always latch base for a Command bound on both base and a modifier layer; this
 * surfaces the modifier layer the row's pills advertise. "" (base) when the row is
 * base-only.
 */
export function rowLatchCombo(row: DiffRow): string {
  for (const p of [...row.b, ...row.a]) {
    if (p.combo) return p.combo;
  }
  return "";
}
